import gql from "graphql-tag";

//Get product capacity
export const GET_CAPACITY = gql`
    query getProductCapacity($id: String!, $currency: String) {
        getProductCapacity(id: $id, currency:$currency) {
            tour_id
            group_id
            departure_date
            units:free_seats
            prices {
                iso_currency_code
                amount
            }
        }
    }
`;